import Vue from 'vue'

Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
});